import { getCountryMessage } from '../../../api'

export const WELCOME_INIT = 'WELCOME_INIT'
export const setWelcome = payload => ({
    type: WELCOME_INIT,
    payload
})

export const action_fetch_init_data = (code, headers) => {
    return async dispatch => {
        const response = await getCountryMessage(code, headers)
        // console.log(response)
        if(response?.code === 200){
            const { result } = response
            dispatch(setWelcome(result))
            return result
        }
        return null
    }
}
